


















































import Vue, { PropType } from 'vue';
import {v4 as uuid} from 'uuid';

export enum DataMode {
    Text = 'text',
    Decimal = 'decimal',
    Hexadecimal = 'hexadecimal',
    Binary = 'binary',
}

export enum Bits {
    Bit = 1, Byte = 8, Word = 16, DWord = 32,
}

export default Vue.extend({
    name: 'data-output',

    data() {
        return {
            currentMode: this.mode,
            id: uuid(),
            savedValue: 0,
        };
    },

    props: {
        value:      { type: [Number, Boolean, String], required: true },
        bits:       { type: Number as PropType<Bits>, required: false, default: (): Bits => Bits.Byte },
        mode:       { type: String as PropType<DataMode>, default: DataMode.Decimal },
        inputStyle: { type: Object, default: (): object => ({}) },
        separator:  { type: Boolean, default: (): boolean => false },
        border:     { type: Boolean, default: (): boolean => false },
    },

    methods: {
        saveValue(e: any): void {   // TODO
            this.savedValue = e.target.value;
        },

        tooltipValue(): string {
            if (this.currentMode === DataMode.Text)
                return '';
            const r = [];
            if (this.currentMode !== DataMode.Decimal)
                r.push(`Decimal: ${this.parsedValue(DataMode.Decimal)}`);
            if (this.currentMode !== DataMode.Hexadecimal)
                r.push(`Hexadecimal: ${this.parsedValue(DataMode.Hexadecimal)}`);
            if (this.currentMode !== DataMode.Binary)
                r.push(`Binary: ${this.parsedValue(DataMode.Binary)}`);
            return r.join(', ');
        },

        parsedValue(mode: DataMode): string {
            const breakEach = (value: string, each: number) => {
                if (!this.separator)
                    return value;
                const r = [];
                for (let i = 0; i < value.length; i += each)
                    r.push(value.substr(i, each));
                return r.join(`_`);
            };
            switch (mode) {
                case DataMode.Decimal:
                    return this.value.toString();
                case DataMode.Text:
                    return (this.value as string);
                case DataMode.Hexadecimal:
                    switch (this.bits) {
                        case Bits.Byte: return `0x${this.value.toString(16).toUpperCase().padStart(2, '0')}`;
                        case Bits.Word: return `0x${this.value.toString(16).toUpperCase().padStart(4, '0')}`;
                        case Bits.DWord: return `0x${breakEach(this.value.toString(16).toUpperCase().padStart(8, '0'), 4)}`;
                    }
                    break;
                case DataMode.Binary:
                    switch (this.bits) {
                        case Bits.Byte: return `0b${this.value.toString(2).padStart(8, '0')}`;
                        case Bits.Word: return `0b${breakEach(this.value.toString(2).toUpperCase().padStart(16, '0'), 8)}`;
                        case Bits.DWord: return `0b${breakEach(this.value.toString(2).toUpperCase().padStart(32, '0'), 8)}`;
                    }
            }
            throw new Error(`Invalid combination of mode (${mode.toString()}) and bits (${this.bits.toString()}).`);
        },

        width() {
            if (this.currentMode === DataMode.Text) {
              return (this.value as string).length;
            }
            switch (this.currentMode) {
                case DataMode.Decimal:
                    switch (this.bits) {
                        case Bits.Byte: return 3 * 8;
                        case Bits.Word: return 5 * 8;
                        case Bits.DWord: return 10 * 8;
                    }
                    break;
                case DataMode.Hexadecimal:
                    switch (this.bits) {
                        case Bits.Byte: return 4 * 8;
                        case Bits.Word: return 6 * 8;
                        case Bits.DWord: return 11 * 8;
                    }
                    break;
                case DataMode.Binary:
                    switch (this.bits) {
                        case Bits.Byte: return 10 * 8;
                        case Bits.Word: return 19 * 8;
                        case Bits.DWord: return 37 * 8;
                    }
                    break;
            }
            throw new Error(`Invalid combination of mode (${this.mode.toString()}) and bits (${this.bits.toString()}).`);
        },
    },
});
